// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qGFG","controls":"styles_controls__1yQub","charLimit":"styles_charLimit__eT5lU","input":"styles_input__3fW49","send":"styles_send__1oGIF"};